<template>
  <div>
    <div class="page-header page-header-small" style="z-index:2;">
      <parallax
        class="page-header-image"
        style="background-image: url('img/background.jpg')!important;background-color:rgba(0,0,0,0)!important;"
      >
      </parallax>
      <div class="content-center">
        <div class="container">
          <h1 class="title">ABOUT US</h1>
        </div>
      </div>
    </div>
    <div style="padding: 60px!important;padding-top:0px!important;margin-top:-90px;">
    <div style="border-radius: 15px;background-color:#f2f0f0;z-index: 3;" class="section section-about-us">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Who we are?</h2>
            <h5 class="description">
              It all started with an idea. A tiny spark with infinite possibilties to ignite a generation. Assembling an incredible team of like minded young people willing to create something fresh, we put our best step forward and we have never looked back since then.<br>
              At Transpo, we believe that determination and hardwork can get us wherever we want. And we work hard, not only to get you from point A to point B, but to make sure  that you have a great experience.
            </h5>
          </div>
        </div>
        <div class="separator separator-primary"></div>
        <div class="section-story-overview">
          <div class="row">
            <div class="col-md-6">
              <div
                class="image-container image-left"
                style="background-image: url('img/about-2.jpg')"
              >
                <!-- First image on the left side -->
                <p class="blockquote blockquote-primary">
                  "Innovation is insights put into action"
                  <br />
                  <br />
                  <small>-Stephen Inoue</small>
                </p>
              </div>
              <!-- Second image on the left side of the article -->
              <div
                class="image-container"
                style="background-image: url('img/about-1.jpg')"
              ></div>
            </div>
            <div class="col-md-5">
              <!-- First image on the right side, above the article -->
              <div
                class="image-container image-right"
                style="background-image: url('img/about-3.jpg')"
              ></div>
              <h3>
                We're a team of enthusiastic, problem solving individuals
              </h3>
              <p>
                Coming from different streams of study and backgrounds, we recognize and understand all the modern day problems related to commute and strongly believe that technology can bridge the gap and make day to day commute faster and cheaper than ever before.
              </p>
              <p>
                That is why we are constantly working to make our app better so that you can book rides hassle free and in no time.
              </p>
              <h4>Safety is our priority</h4>
              <p>At Transpo our top priority is and will always be safety. Being in close contact with our partner vendors and drivers, we ensure a harmless business environment which will never affect the rider in any way possible. We consider gaining the trust of our users an achievement and are always striving to make the cab riding experience safe and convenient. </p>
              <h4>No shortcuts</h4>
              <p>What really sets us apart is that unlike any other online cab booking services, we have a clear business model with no loop holes or grey areas. All team members work on the lines of company's code of ethics and is the first prerequisite for any employee working with Transpo. </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div class="section section-team text-center" style="padding-top:80px;background-color: #F9F9F9;">
      <div class="container">
        <h2 class="title">Here is our team</h2>
        <div class="team" style="padding-top: 100px;">
            <div class="row" style="margin-bottom: 100px;">
                <div class="col-md-6 col-lg-4 offset-lg-2">
                    <profilecard name="Himanshu Bhalani" title="Founder" img="himanshu.jpg" linkedin="https://www.linkedin.com/in/himanshu-bhalani-1a7715172/"></profilecard>
                </div>
                <div class="col-md-6 col-lg-4">
                    <profilecard name="Supragya Bajpai" title="Co-Founder" img="supragya.jpg" linkedin="https://www.linkedin.com/in/supragya-bajpai"></profilecard>
                </div>
            </div>
            <div class="row" style="margin-bottom: 100px;">
                <div class="col-lg-3 col-md-6 col-sm-12">
                    <profilecard name="Narayanan T.K" title="Content Head" img="narayanan.jpg" linkedin="https://www.linkedin.com/in/narayanan-tk-019909191"></profilecard>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12">
                    <profilecard name="Ayush Sharda" title="HR Head" img="ayush-sharda.jpg" linkedin="https://www.linkedin.com/in/ayush-sharda-508535188"></profilecard>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12">
                    <profilecard name="Suhetu Ring" title="Technical Head" img="suhetu.jpg" linkedin="https://www.linkedin.com/in/suhetu-ring"></profilecard>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12">
                    <profilecard name="Rishabh Chopra" title="Marketing Head" img="rishabh.jpg" linkedin="https://www.linkedin.com/in/rishabh-chopra-59600b191"></profilecard>
                </div>
            </div>
            <div class="row" style="margin-bottom: 100px;">
                <template v-for="(x, i) in team">
                    <div class="col-lg-3 col-md-4 col-sm-12" :key="i">
                        <profilecard :name="x.name" :title="x.title" :img="x.img" :linkedin="x.linkedin"></profilecard>
                    </div>
                </template>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, FormGroupInput } from '../components';
import profilecard from '../components/Cards/profilecard.vue';
export default {
  name: 'landing',
  bodyClass: 'landing-page',
  components: {
    profilecard,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  data() {
    return {
      team: [
          {'name': 'Piyush Jha', 'title': 'Tech Team', 'img': 'piyush.jpg', 'linkedin': 'https://www.linkedin.com/in/hackinet/'},
          {'name': 'Anmol Srivastava', 'title': 'Tech Team', 'img': 'anmol.jpg', 'linkedin': 'https://www.linkedin.com/in/anmolsri150/'},
          {'name': 'Mitali Sethi', 'title': 'Tech Team', 'img': 'mitali.jpg', 'linkedin': 'https://www.linkedin.com/in/mitali-sethi-3b1879165/'},
          {'name': 'Jaideep Sachdeva', 'title': 'Tech Team', 'img': 'jaideep.jpg', 'linkedin': 'https://www.linkedin.com/in/jaideep-singh-sachdev-2b4985175'},
          {'name': 'Deepanshu Pathak', 'title': 'Marketing Team', 'img': 'deepanshu.jpg', 'linkedin': 'https://www.linkedin.com/in/deepanshu-pathak-5aaa4b187'},
          {'name': 'Priyansh Jain', 'title': 'Marketing Team', 'img': 'priyansh.jpg', 'linkedin': 'https://www.linkedin.com/in/priyansh-jain-b66358191'},
          {'name': 'Divy Makkar', 'title': 'Marketing Team', 'img': 'divy.jpg', 'linkedin': 'https://www.linkedin.com/in/divy-makkar-195245168'},
          {'name': 'Namita Tahilyani', 'title': 'HR Team', 'img': 'namita.jpg', 'linkedin': 'https://www.linkedin.com/in/namita-tahilyani-58ba45192'},
          {'name': 'Aayush Kumar', 'title': 'HR Team', 'img': 'aayush.jpg', 'linkedin': 'https://www.linkedin.com/in/aayushakumars'},
          {'name': 'Ritik Mehta', 'title': 'Content Team', 'img': 'ritik.jpg', 'linkedin': 'https://www.linkedin.com/in/ritik-mehta-917a28183'},
          {'name': 'Manveer Mathur', 'title': 'Content Team', 'img': 'manveer.jpg', 'linkedin': 'https://www.linkedin.com/in/manveer-mathur-159783193'},
          {'name': 'Gaurisha Tyagi', 'title': 'Content Team', 'img': 'gaurisha.jpg', 'linkedin': '#'},
      ]
    };
  }
};
</script>
<style>
    .wrapper {
    background-color: #94969c;
    }
</style>
